import {on, find, removeClass, findIn, closest, toggleClass, trigger, addClass} from "@elements/dom-utils";
import TerracePlanner from "../index";

/**
 * scales the whole svg based on the bounding box of the container that holds the <rect>s
 * uses the svg's viewBox so the value inside it don't have to be scaled one by one
 *
 * adds a margin to both width and height so the letters can still be outside the outline
 */
export function scale() {
    if (document.getElementById('outlineSvg')) {
        let viewBox = document.getElementById('outlineSvg').viewBox.baseVal;

        let outlineContainer = document.getElementById('outlineContainer');
        let boundingBox = outlineContainer.getBBox();

        updateMargin(Math.max(boundingBox.width, boundingBox.height));
        let halfMargin = TerracePlanner.MARGIN / 2;

        outlineContainer.setAttribute('transform', 'translate(' + halfMargin + ',' + halfMargin + ')');
        viewBox.width = boundingBox.width + TerracePlanner.MARGIN;
        viewBox.height = boundingBox.height + TerracePlanner.MARGIN;
    }
}

function updateMargin(dimension) {
    let margin = (dimension / 10) + 20;

    TerracePlanner.MARGIN = margin;
    document.getElementById('margin').value = margin;
}